import React from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Route, Routes as Switch } from 'react-router-dom';

import AuthenticatedLayout from 'App/components/AuthenticatedLayout';
import AuthenticatedRoutes from 'App/features/AuthenticatedRoutes';
import PublicRoutes from 'App/features/PublicRoutes';
import TrackingLoader from 'App/utils/TrackingLoader';
import { catchPhrase } from './app/components/config/config';
import Dynatrace from 'App/components/Dynatrace';

const Routes = () => {
    return (
        <BrowserRouter>
            <TrackingLoader />
            <Dynatrace />
            <Helmet>
                <title>{catchPhrase}</title>
            </Helmet>
            <Switch>
                {/* ---- Public routes (no auth required) ---- */}
                {PublicRoutes}

                <Route element={<AuthenticatedLayout />}>
                    <Route path="/*" element={<AuthenticatedRoutes />} />
                </Route>
            </Switch>
        </BrowserRouter>
    );
};

export default Routes;
